export interface NetworkErrorOptions {
  cause?: unknown;
  url?: string;
}

/**
 * Thrown when a network request fails before a usable HTTP response (e.g. offline, DNS).
 */
export class NetworkError extends Error {
  readonly url?: string;

  constructor(message: string, options?: NetworkErrorOptions) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = "NetworkError";
    this.url = options?.url;
  }
}
